var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconePertinence(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.30198L17.3886 9.44917C17.5326 9.7954 17.8582 10.032 18.232 10.0619L27.0276 10.7671L20.3263 16.5075C20.0415 16.7514 19.9171 17.1342 20.0041 17.4989L22.0515 26.0819L14.5213 21.4825C14.2012 21.287 13.7988 21.287 13.4787 21.4825L5.94851 26.0819L7.99586 17.4989C8.08287 17.1342 7.9585 16.7514 7.67371 16.5075L0.972408 10.7671L9.76798 10.0619C10.1418 10.032 10.4674 9.7954 10.6114 9.44917L14 1.30198Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePertinence);
export default __webpack_public_path__ + "static/media/iconePertinence.df9f00483e82e2c7f8d3c1296c5dfdce.svg";
export { ForwardRef as ReactComponent };